@if ((compatibility | async) === null) {
  <div class="layout-page">
    <div class="ng-content">
      <ng-content></ng-content>
    </div>
    <app-layout-footer class="layout-footer"></app-layout-footer>
  </div>
}
@if (compatibility | async) {
  <div class="layout-page">
    <div class="ng-content">
      <app-layout-header></app-layout-header>
      <app-layout-content>
        <app-compatibility [compatibility]="compatibility | async"></app-compatibility>
      </app-layout-content>
    </div>
    <app-layout-footer class="layout-footer"></app-layout-footer>
  </div>
}
